<template>
    <v-card class="rounded-card pa-3 pb-1">
      <v-card-title class="primary--text pt-1 pb-0">
        <v-row>
          <v-col
            order-lg="2"
            cols="12"
            lg="6"
            class="text-uppercase primary--text text-center font-weight-black py-0"
            :class="{ 'subtitle-1 font-weight-black': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }"
          >
            Facturas
            <span class="ml-1" v-if="statusFilter === status.RECHAZADA">Rechazadas</span>
            <span class="ml-1" v-if="statusFilter === status.REGISTRADO">Pendientes</span>
            <span class="ml-1" v-if="statusFilter === status.AUTORIZADA">Autorizadas</span>
            <span class="ml-1" v-if="statusFilter === status.PREVENTA">En Validación</span>
            <span class="ml-1" v-if="statusFilter === status.CREDITO">En crédito
              <p
                class="subtitle-1 text-none text-no-wrap"
                v-if="showReference"
              >
                Selecciona las facturas que deseas liquidar
              </p>
            </span>
          </v-col>
          <v-col order-lg="1" cols="12" lg="3" class="py-0">
            <v-text-field rounded outlined dense v-model="search" label="Buscador"/>
          </v-col>
          <v-col order-lg="3" cols="12" lg="3" class="text-left py-0">
            <v-chip
              class="mr-2 font-weight-black active-chip caption"
              @click="toggleCurrencyFilter('USD')">
              <v-avatar class="ml-0">
                <v-icon color="white" v-if="!isFilterBy('USD')">mdi-crop-square</v-icon>
                <v-icon color="white" v-if="isFilterBy('USD')">mdi-checkbox-marked</v-icon>
              </v-avatar>
              <span class="ml-1">USD</span>
            </v-chip>
            <v-chip
              class="pr-3 font-weight-black active-chip caption"
              @click="toggleCurrencyFilter('MXN')">
              <v-avatar class="ml-0">
                <v-icon color="white" v-if="!isFilterBy('MXN')">mdi-crop-square</v-icon>
                <v-icon color="white" v-if="isFilterBy('MXN')">mdi-checkbox-marked</v-icon>
              </v-avatar>
              <span class="ml-1">MXN</span>
            </v-chip>
              <!-- <span style="font-size: 10px;">Width: {{ window.width }} px <br> Height: {{ window.height }} px <br>
                {{getHeight($vuetify.breakpoint)}}</span> -->
            <!-- <span v-show="currencyFilter.length === 0" class="subtitle-1 text-none font-weight-bold error--text"><br>Selecciona una moneda</span> -->
            <v-btn
              fab
              right
              absolute
              width="30"
              height="30"
              class="mt-2 close-button"
              color="blue"
              @click="$emit('onClose')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <p
              v-show="currencyFilter.length === 0"
              class="subtitle-1 text-none font-weight-bold error--text text-left"
              style="word-break: normal"
            >
              Selecciona una moneda
            </p>
          </v-col>
        </v-row>
        <!-- <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" >
          <v-col cols="12" >
          </v-col>
        </v-row> -->
      </v-card-title>
      <!-- <v-card-text v-bind:style="{ height: getHeight($vuetify.breakpoint).scrollHeight }"> -->
      <v-card-text style="height: 80vh;">
        <v-row align="center">
              <v-data-table
                :height="getHeight($vuetify.breakpoint).tableHeight"
                :fixed-header="true"
                :headers="headersByStatus"
                :items="invoicesFiltered"
                :sort-by="[sortDate, 'receiverName']"
                :sort-asc="[false, true]"
                multi-sort
                :show-select="statusFilter === status.CREDITO && showReference"
                :single-select="false"
                item-key="uuid"
                v-model="selected"
                no-data-text="No hay datos para mostrar"
                class="elevation-1"
                :footer-props="{
                  'items-per-page-all-text': 'Todos',
                  'items-per-page-options': [-1],
                  'disable-pagination': true
                }"

              >
                <!-- <template v-slot:header.automaticPayment="{ header }">
                  ¿Pago<br>Automático?
                </template> -->
                <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                  <v-checkbox
                    v-if="!item.paymentReference && !isAutomaticPayment(item)"
                    hide-details
                    dense
                    class="ma-0"
                    type="checkbox"
                    :value="isSelected"
                    @change="select($event)"
                  />
                </template>
                <template v-slot:[`header.estadoComentario`]>
                  <span>
                    ESTADO
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          color="#1976D2"
                          v-on="on"
                          v-bind="attrs"
                          style="cursor:pointer;vertical-align:middle;"
                        >mdi-information-outline</v-icon>
                      </template>
                      <span>Última actualización de la factura proporcionada por American Industries.</span>
                    </v-tooltip>
                  </span>
                </template>
                <template v-slot:[`item.estadoComentario`]="{ item }">
                  <span>
                    {{ getLatestStatusComment(item) }}
                  </span>
                </template>
                <template v-slot:[`item.folio`]="{ item }">
                  <span>
                    <v-tooltip bottom text="Tooltip" v-if="item.exchangeRate !== 1">
                      <template v-slot:activator="{ on }">
                        <span v-on="on"><v-icon color="#004D40" small v-on="on">mdi-information</v-icon></span>
                      </template>
                      Esta factura fue convertida de {{item.originalCurrency}} a {{item.currency}}
                    </v-tooltip>
                    {{item.folio}}
                  </span>
                  <span v-if="showReference && isAutomaticPayment(item) === true && item.status === status.CREDITO" class="automaticPayment">
                    <br>
                    <v-icon color="#004D40" small>mdi-credit-card-wireless</v-icon>
                    Pago automático
                  </span>
                </template>
                <template v-slot:[`item.advancePayment`]="{ item }">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ parseFloat(item.initialDeposit) | currency }} {{ item.currency }}</span>
                    </template>
                    <span v-if="item.status === status.CREDITO">Efectivo depositado</span>
                    <span v-else>Efectivo a depositar</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.preAdvancePayment`]="{ item }">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ parseFloat(item.adelanto) - parseFloat(item.comision) | currency}} {{ item.currency }}</span>
                    </template>
                    <span>Efectivo estimado a depositar</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.total`]="{ item }">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ parseFloat(item.total) | currency}} {{ item.currency }}</span>
                    </template>
                    <span>Monto total por liquidar</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.aforo`]="{ item }">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ parseFloat(item.aforo) | currency}} {{ item.currency }}</span>
                    </template>
                    <span>Monto retenido por concepto de aforo</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.initialDeposit`]="{ item }">
                  <span>{{ parseFloat(item.initialDeposit) | currency}} {{ item.currency }}</span>
                </template>
                <template v-slot:[`item.comision`]="{ item }">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ parseFloat(item.comision) | currency}} {{ item.currency }}</span>
                    </template>
                    <span>Interés por cobrar por plazo solicitado</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.motiveCode`]="{ item }">
                  <span>{{ item.motive.description }}</span>
                </template>
                <template v-slot:[`item.paymentReference`]="{ item }">
                  <v-chip v-if="item.paymentReference" class="caption font-weight-light" color="gray">
                    {{ item.paymentReference }}
                  </v-chip>
                </template>
                <template v-slot:[`item.receiverName`]="{ item }">
                  <v-tooltip v-if="item.status === status.CREDITO" bottom color="black">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="text-uppercase">
                        {{ item.receiverName }}
                      </span>
                    </template>
                    <span>{{ colorBasedInDueDate(item).message }}</span>
                  </v-tooltip>
                  <span v-else class="text-uppercase">{{ item.receiverName }}</span>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <v-tooltip right color="black">
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" :color="colorBasedInDueDate(item).color">mdi-circle</v-icon>
                    </template>
                    <span>{{ colorBasedInDueDate(item).message }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon color="success" v-if="item.motive.user" @click="restoreInvoice(item)">mdi-file-restore</v-icon>
                </template>
                <template v-slot:[`item.emittedOn`]="{ item }">
                    {{ item.emittedOn | dateShort }}
                </template>
                <template v-slot:[`item.fechaDeposito`]="{ item }">
                    {{ item.fechaDeposito | dateShort }}
                </template>
                <template v-slot:[`item.dueDate`]="{ item }">
                    {{ item.dueDate | dateShort }}
                </template>
                <template v-slot:[`item.rejectedDate`]="{ item }">
                    {{ item.rejectedDate | dateShort }}
                </template>
                <!-- <template v-slot:item.payment="{ item }" v-if="showReference">
                  <span>{{isAutomaticPayment(item)}}</span>
                </template> -->
              </v-data-table>
        </v-row>
      </v-card-text>
      <v-card-text :style="{ 'height': $vuetify.breakpoint.mdAndUp ? '13vh': '20vh' }" style="overflow-y: hidden" class="pt-1 pb-0">
        <v-row class="text-center primary--text" align="center" justify="center">
            <v-col
              v-if="statusFilter === status.CREDITO && showReference"
              class="py-1 my-0"
            >
              <v-btn
                color="#5C9DF2"
                :dark="selected.length > 0"
                class="my-auto font-weight-black"
                :disabled="selected.length < 1"
                @click="setPaymentReference()">Generar referencia de pago
              </v-btn>
            </v-col>
            <v-col class="py-1 my-0" v-if="statusFilter === status.CREDITO">
              <ExportTable
                :fileName="fileName"
                :mapFunction="mapFunction"
                :dataToExport="invoicesFiltered"
                :headers="excelHeaders"
              />
            </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import FactoringDocumentService from '@/services/FactoringDocumentService'
import ClientService from '@/services/ClientService'
import moment from 'moment'
import Status from '@/common/FactoringDocumentStatus'
import CommentsStatusAI from '@/common/CommentsStatusAI'
import Vue from 'vue'
import ExportTable from '@/components/ExportTable'
import Mixins from '@/mixins/index.js'

export default {
  name: 'InvoiceTable',
  mixins: [Mixins],
  components: {
    ExportTable
  },
  props: {
    statusFilter: Number,
    productFilter: {
      type: Number,
      required: true
    },
    productTypes: {
      type: Object,
      required: true
    },
    costCenters: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    fileName: 'Facturas en crédito',
    window: {
      width: 0,
      height: 0
    },
    search: '',
    sortDate: 'emittedOn',
    // selectAll: false,
    currencyFilter: ['MXN', 'USD'],
    selected: [],
    singleSelect: true,
    showReference: true,
    status: Status,
    excludeFB: [
      'paymentReference'
    ],
    headers: [
      // {
      //   text: '',
      //   value: 'selected',
      //   status: [30],
      //   align: 'center',
      //   class: 'primary--text font-weight-black text-uppercase'
      // },
      // { text: 'RFC', value: 'receiverRFC', status: [0, 10, 30] },
      { text: '', sortable: false, value: 'status', status: [30], align: 'center' },
      {
        text: 'Razón Social',
        align: 'left',
        sortable: true,
        value: 'receiverName',
        status: [
          Status.RECHAZADA,
          Status.REGISTRADO,
          Status.AUTORIZADA,
          Status.PREVENTA,
          Status.CREDITO
        ],
        class: 'primary--text font-weight-black text-uppercase'
      },
      {
        text: 'Factura',
        value: 'folio',
        status: [
          Status.RECHAZADA,
          Status.REGISTRADO,
          Status.AUTORIZADA,
          Status.PREVENTA,
          Status.CREDITO
        ],
        align: 'center',
        class: 'primary--text font-weight-black text-uppercase'
      },
      {
        text: 'Estado',
        value: 'estadoComentario',
        status: [
          Status.PREVENTA
        ],
        align: 'center',
        class: 'primary--text font-weight-black text-uppercase'
      },
      {
        text: 'F. Emisión',
        value: 'emittedOn',
        status: [
          Status.RECHAZADA,
          Status.REGISTRADO,
          Status.AUTORIZADA,
          Status.PREVENTA,
          Status.CREDITO
        ],
        align: 'center',
        class: 'primary--text font-weight-black text-uppercase'
      },
      {
        text: 'F. Depósito',
        value: 'fechaDeposito',
        status: [
          Status.CREDITO
        ],
        align: 'center',
        class: 'primary--text font-weight-black text-uppercase'
      },
      {
        text: 'Promesa pago',
        value: 'dueDate',
        status: [Status.CREDITO],
        align: 'center',
        class: 'primary--text font-weight-black text-uppercase',
        sort: (a, b) => {
          const am = moment(a, 'YYYY-MM-DD').format('YYYY/MM/DD')
          const bm = moment(b, 'YYYY-MM-DD').format('YYYY/MM/DD')
          if (am === bm) {
            return 0
          } else {
            if (am < bm) {
              return -1
            } else {
              return 1
            }
          }
        }
      },
      { text: 'Fecha Rechazo', value: 'rejectedDate', status: [Status.RECHAZADA], align: 'center', class: 'primary--text font-weight-black text-uppercase' },
      {
        text: 'Anticipo',
        value: 'preAdvancePayment',
        status: [
          Status.PREVENTA
        ],
        align: 'right',
        class: 'primary--text font-weight-black text-uppercase'
      },
      {
        text: 'Anticipo',
        value: 'advancePayment',
        status: [
          // Status.RECHAZADA,
          Status.REGISTRADO,
          Status.AUTORIZADA,
          Status.CREDITO
        ],
        align: 'right',
        class: 'primary--text font-weight-black text-uppercase'
      },
      { text: 'Interés', value: 'comision', status: [Status.REGISTRADO, Status.CREDITO], align: 'right', class: 'primary--text font-weight-black text-uppercase' },
      { text: 'Aforo', value: 'aforo', status: [Status.REGISTRADO, Status.CREDITO], align: 'right', class: 'primary--text font-weight-black text-uppercase' },
      { text: 'Total', value: 'total', status: [Status.RECHAZADA, Status.REGISTRADO, Status.AUTORIZADA, Status.PREVENTA, Status.CREDITO], align: 'right', class: 'primary--text font-weight-black text-uppercase' },
      { text: 'Referencia', value: 'paymentReference', status: [Status.CREDITO], align: 'right', class: 'primary--text font-weight-black text-uppercase' },
      { text: 'Motivo', value: 'motiveCode', status: [Status.RECHAZADA], class: 'primary--text font-weight-black text-uppercase' },
      { text: 'Acciones', value: 'actions', status: [Status.RECHAZADA], align: 'center', class: 'primary--text font-weight-black text-uppercase' }
      // { text: 'Pago automático', value: 'automaticPayment', status: [Status.CREDITO], align: 'center', class: 'primary--text font-weight-black text-uppercase' }
    ],
    excelHeaders: {
      receiverName: 'Receptor',
      folio: 'Factura',
      emittedOn: 'Fecha de emisión',
      fechaDeposito: 'Fecha de Depósito',
      dueDate: 'Promesa de pago',
      advancePayment: 'Anticipo',
      comision: 'Interés',
      aforo: 'Aforo',
      total: 'Total',
      paymentReference: 'Referencia de pago'
    }
  }),
  async mounted () {
    this.selected = []
    if (this.productTypes.FB.productId === this.productFilter) {
      this.showReference = false
    }
  },
  // created () {
  //   window.addEventListener('resize', this.handleResize)
  //   this.handleResize();
  // },
  computed: {
    headersByProduct () {
      if (this.productTypes) {
        if (this.productTypes.FB.productId === this.productFilter) {
          return this.headers.filter(item => !this.excludeFB.includes(item.value))
        } else {
          return this.headers.filter(item => item.value !== 'estadoComentario')
        }
      }
      return this.headers.map(item => item)
    },
    headersByStatus () {
      return this.headersByProduct.filter(header => header.status.includes(this.statusFilter))
    },
    invoicesByStatus () {
      for (const invoice of this.$store.getters.invoices) {
        invoice.selected = false
      }
      let invoices = this.$store.getters.invoices.filter(invoice => invoice.status === this.statusFilter)
      if (this.productFilter) {
        invoices = invoices.filter(invoice => invoice.productId === this.productFilter)
      }
      return invoices
    },
    invoicesByCurrency () {
      return this.invoicesByStatus.filter(invoice => this.currencyFilter.includes(invoice.currency))
    },
    invoicesFiltered () {
      let invoices = this.invoicesByCurrency
      if (this.search.length > 0) {
        invoices = invoices.filter(invoice => JSON.stringify(invoice).toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
      }

      if (this.statusFilter === Status.CREDITO) {
        this.setSortDate('dueDate')
      }
      return invoices
    }
  },
  methods: {
    mapFunction (item) {
      return Object.assign({
        receiverName: item.receiverName,
        folio: item.folio,
        emittedOn: item.emittedOn,
        fechaDeposito: item.fechaDeposito,
        dueDate: item.dueDate,
        advancePayment: parseFloat(item.total) - parseFloat(item.aforo || 0) - parseFloat(item.comision),
        comision: item.comision,
        aforo: item.aforo,
        total: item.total,
        paymentReference: item.paymentReference
      })
    },
    getHeight (breakpoint) {
      if (breakpoint.lg || breakpoint.xl) {
        return {
          tableHeight: '540',
          scrollHeight: '600px'
        }
      }
      if (breakpoint.md) {
        return {
          tableHeight: '385',
          scrollHeight: '385px'
        }
      }
      if (breakpoint.sm) {
        return {
          tableHeight: '465',
          scrollHeight: '60vh'
        }
      }
      if (breakpoint.xs) {
        return {
          tableHeight: '400',
          scrollHeight: '40vh'
        }
      }
    },

    colorBasedInDueDate (item) {
      const diff = moment().startOf('day').diff(moment(item.dueDate, 'YYYY-MM-DD'), 'days')
      if (diff >= 0) {
        return { color: '#d50a0a', message: 'Factura vencida, te sugerimos realizar tu pago inmediatamente' }
      }
      if (diff >= -7) {
        return { color: '#FFD54F', message: 'Factura próxima a vencer' }
      }
      if (diff < -7) {
        return { color: '#4CAF50', message: 'Factura al corriente' }
      }
      return { color: '', message: '' }
    },

    setSortDate (field) {
      this.sortDate = field
    },

    // toggleSelectAll () {
    //   for (let item of this.invoicesFiltered) {
    //     if (!item.paymentReference) {
    //       Vue.set(item, 'selected', this.selectAll)
    //     }
    //   }
    // },

    async setPaymentReference () {
      const invoices = this.selected.filter(item => {
        if (this.isAutomaticPayment(item) === false && !item.paymentReference) {
          return item
        }
      })

      if (invoices.length <= 0) {
        this.$swal({
          title: 'Error',
          html: 'Ninguna factura seleccionada',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#5c9df2',
          allowOutsideClick: false,
          showCloseButton: false
        })
        return
      }

      const selectedCurrencies = [...new Set(invoices.map(item => item.currency))]
      if (selectedCurrencies.length > 1) {
        return this.$swal('Error!', 'Selecciona facturas de una sola moneda para poder generar la referencia', 'error')
      }

      let referenceId = null
      let message = '<span>Se generará una referencia de pago </span>'
      if (invoices.length > 0) {
        message += '<span>con <strong>' + invoices.length + '</strong> factura(s) teniendo un total de </span>'
      }
      const invoicesMXN = invoices.filter(item => item.currency === 'MXN')
      const invoicesUSD = invoices.filter(item => item.currency === 'USD')
      if (invoicesMXN.length > 0) {
        const total = this.$options.filters.currency(parseFloat(invoicesMXN.map(item => item.total).reduce((accum, value) => parseFloat(accum) + parseFloat(value))))
        message += '<strong>' + total + ' MXN</strong>'
      }
      if (invoicesUSD.length > 0) {
        const total = this.$options.filters.currency(parseFloat(invoicesUSD.map(item => item.total).reduce((accum, value) => parseFloat(accum) + parseFloat(value))))
        if (invoicesMXN.length > 0) {
          message += '<strong> y ' + total + ' USD</strong>'
        } else {
          message += '<strong>' + total + ' USD</strong>'
        }
      }
      const { value } = await this.$swal({
        title: '¿Deseas generar esta referencia?',
        html: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Si',
        confirmButtonColor: '#1374F2',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCloseButton: true,
        allowOutsideClick: true
      })
      if (value) {
        const loader = this.$loading.show()
        try {
          await Promise.all(invoices.map(item => FactoringDocumentService.findOrCreate({ invoice: item, clientId: this.$store.getters.user.clientId })))
          const { data } = await FactoringDocumentService.setPaymentReference({ invoices: invoices.map(item => Object.assign({}, { uuid: item.uuid })) })

          if (data.rowsUpdated > 0) {
            for (const invoice of this.$store.getters.invoices) {
              if (invoices.some(item => item.uuid === invoice.uuid)) {
                invoice.paymentReference = data.paymentReference
              }
            }
            referenceId = await this.addClientPaymentReference(data.paymentReference, data.rowsUpdated, this.selected)
            if (!referenceId) {
              throw new Error('NO_PAYMENT_REFERENCE_ID')
            }
          }
          loader.hide()
          this.$emit('generated', { paymentReference: data.paymentReference, invoices: this.selected, referenceId: referenceId })
        } catch (error) {
          loader.hide()
          this.$swal({
            title: 'Error',
            html: error.response?.data?.message || error.message ? this.$t(error.response?.data?.message || error.message) : 'Ha ocurrido un error, contacta al administrador',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#5c9df2',
            allowOutsideClick: false,
            showCloseButton: false
          }).then(async (result) => {
            this.$emit('onClose')
          })
        }
      }
    },
    async addClientPaymentReference (paymentReference, count, invoices) {
      const data = {
        clientId: this.$store.getters.user.clientId,
        user: {
          email: this.$store.getters.user.email,
          fullName: this.$store.getters.user.fullName || ''
        },
        paymentReference: paymentReference,
        count: count
      }
      try {
        const paymentReference = {
          count: count,
          reference: data.paymentReference,
          userId: this.$store.getters.user.userId,
          clientId: this.$store.getters.user.clientId
        }
        const { id } = await ClientService.addPaymentReference(paymentReference)
        // paymentReference.invoicesMXN = invoices.filter(invoice => invoice.currency === 'MXN')
        // paymentReference.invoicesUSD = invoices.filter(invoice => invoice.currency === 'USD')
        // paymentReference.totalMXN = paymentReference.invoicesMXN.length > 0 ? paymentReference.invoicesMXN
        //   .map(invoice => invoice.total)
        //   .reduce((a, b) => parseFloat(a) + parseFloat(b)) : 0
        // paymentReference.totalUSD = paymentReference.invoicesUSD.length > 0 ? paymentReference.invoicesUSD
        //   .map(invoice => invoice.total)
        //   .reduce((a, b) => parseFloat(a) + parseFloat(b)) : 0
        // paymentReference.totalMXN = parseFloat(paymentReference.totalMXN)
        // paymentReference.totalUSD = parseFloat(paymentReference.totalUSD)
        // this.$store.dispatch('pushPaymentReference', paymentReference)
        return id
      } catch (error) {
        console.error('error', error)
      }
      return null
    },
    isFilterBy (value) {
      if (this.currencyFilter.includes(value)) { return true }
      return false
    },
    toggleCurrencyFilter (currency) {
      const index = this.currencyFilter.findIndex(item => item === currency)
      if (index < 0) {
        this.currencyFilter.push(currency)
      } else {
        this.currencyFilter.splice(index, 1)
      }
    },
    restoreInvoice (invoice) {
      this.$swal({
        title: '¿Deseas restaurar esta factura?',
        html: 'Reaparecerá disponible para venta',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Si',
        confirmButtonColor: '#1374F2',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCloseButton: true,
        allowOutsideClick: true
      }).then(async (result) => {
        if (result.value) {
          try {
            const payload = {
              documentId: invoice.documentId,
              clientUserId: this.$store.getters.user.userId
            }
            await FactoringDocumentService.restoreByUser(payload)
            Vue.set(invoice, 'status', Status.REGISTRADO)
            await this.$store.dispatch('updateInvoicesGroups')
            this.$swal('Éxito', 'Factura rehabilitada', 'success')
          } catch (error) {
            console.error(error)
            this.$swal('Error!', 'Acción no disponible de momento, intenta mas tarde', 'error')
          }
        }
      })
    },
    isAutomaticPayment (invoice) {
      if (this.costCenters && this.costCenters.length > 0) {
        const payer = this.costCenters.find(item => item.active === true && item.rfcPayer === invoice.receiverRFC)
        if (payer && invoice.currency === 'MXN') {
          return true
        }
      }
      return false
    },
    getLatestStatusComment (item) {
      if (!item || !item.statusResponse || item.statusResponse.length === 0) return ''
      const latest = (item && item.statusResponse && item.statusResponse.length) ? item.statusResponse.reduce((a, b) => (new Date(a.dateProcess) > new Date(b.dateProcess) ? a : b)) : ''
      const comment = latest && latest.respuesta && latest.respuesta.comments ? latest.respuesta.comments : ''
      return CommentsStatusAI[comment] || comment || ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-data-table {width: 100% !important;}
  .v-data-table-header span {white-space: nowrap;}
  .rounded-card { border-radius: 50px !important; }
  .factoring-icon { width: 2rem; }
</style>
